'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var COOKIE_NAME_USER_PACKAGE = exports.COOKIE_NAME_USER_PACKAGE = 'rp_package';
var COOKIE_NAME_DB_USER_ID = exports.COOKIE_NAME_DB_USER_ID = 'rp_uid';
var COOKIE_NAME_UNIQUE_USER_ID = exports.COOKIE_NAME_UNIQUE_USER_ID = '__t';
var COOKIE_NAME_USER_LOGIN = exports.COOKIE_NAME_USER_LOGIN = 'rp_email';
var COOKIE_LAST_LOGGED_IN_WEB = exports.COOKIE_LAST_LOGGED_IN_WEB = 'rp_last_logged_in_date_web';

var COOKIE_UTM_KEY_FIRST = exports.COOKIE_UTM_KEY_FIRST = 'utmFirst';
var COOKIE_UTM_KEY_LAST = exports.COOKIE_UTM_KEY_LAST = 'utmLast';


//////////////////
// WEBPACK FOOTER
// ./~/rp-betting-special-offer/~/rp-analytics/lib/utils/cookie/constants.js
// module id = 151
// module chunks = 0